<template>
  <div class='contract' style="position: relative;">
    <div class='block'>
      <div class='contract-sign-check dis-bok'>
        <p class='read-text dis-bok'>阅读合同条款</p>
        <div class='contract-text'>
          <div class='contract-text-next'>
            <div class='mt10'>
              <img class='contract-sign-img' src='../../assets/img/contract-sign3.png' />
              <a target='_blank' :href='contractSrc' class='contract-src'>{{contractText}}</a>
            </div>
          </div>
        </div>
        <div class='mt10'>
          <p class='sign-check-p' @click='checkSign()'>
            <input type='checkbox' class='parent-menus' v-model='checkStatus'>
            <span>我已阅读合同条款，并同意</span>
          </p>
        </div>
        <!-- <div class='contract-remind mt10'>
          如对合同条款内容有疑义可致电客服热线：
          <a class='fcblue' :href='telText' style='display: inline-block;'>{{tel}}</a>
        </div> -->
        <br />
      </div>
      <div v-show="checkStatus" class='contract-sign-check dis-bok' style='margin-top: 10px;'>
        <p class='read-text dis-bok'>添加《个人签名》</p>
        <div class='sign-position' style='position: relative;'>
          <img class="canvas-img" :src="signSrc" @click="signStatusChange()" />
        </div>
      </div>
    </div>
    <div class="mask-mine" v-show='signHidden'></div>
    <div class="sign-content" v-show='signHidden' style="width: calc(100% - 10px); margin: 0 5px; top: 100px;">
      <div class="sign-header" style="height: 44px; line-height: 44px;">
        <span class="middle">手写签名</span>
      </div>
      <div class="sign-container" style="padding: 5px;">
        <canvas id="canvas" class="canvas" ref="canvasF" :width="width" :height="height" @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)"></canvas>
      </div>
      <div class="sign-footer">
        <button class="btn-reset btn-sign" @click="signStatusChange()">取消</button>
        <button class="btn-reset btn-sign" @click="cleardraw()">重置</button>
        <button class="btn-save btn-sign" @click="getimg()">确定</button>
      </div>
    </div>
    <van-button v-if="submitVisible" class="go-business button-primary" :disabled="loadingSign" :loading="loadingSign" loading-text="提交签名"
     @click="submitSign()">提交签名</van-button>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Button, Form, Field, Checkbox, Picker, Uploader, Popup } from 'vant'
import { getBusDetailReq, nextBusinessReq } from '@/api/manage'
import { formDataPost } from '../../utils/axiosfunc'

Vue.use(Notify)
Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(Picker)
Vue.use(Uploader)
Vue.use(Popup)

export default {
  data () {
    return {
      temp: '',
      objCommit: {},
      checkStatus: false,
      isDraw: false,
      submitVisible: false,
      loadingSign: false,
      datas: '',
      // contractSrc: 'https://file.wisewater.cn/group1/M00/0B/F0/rBAABV-BcqeACqQWAAG9x1RXzYo756.pdf',
      // contractSrc: 'http://file.wisewater.cn/group1/M01/10/B2/rBAABWDAWpGAKWQNAAxXsXOEIXg076.png',
      contractSrc: '',
      contractText: '《供用水服务协议》',
      tel: '1234567',
      telText: 'tel:1234567',
      signSrc: 'data:image/gif;base64,R0lGODlhhwBIAJECAL6+vtHR0f///wAAACH5BAEAAAIALAAAAACHAEgAAAL/jI+py+0Po5y02ouz3rz7Dx7CSJbmiabqyrbuC6NLTNf2jddKzvf+r9oBh8TiS2hMKo3IpfOJa0KnVJa0is0Krtruk+sNMxPi8hJsTufQ6jaN7Y634PK6jGzPu+j6PL9f9wcYJzjYVmiYhphYtngCAMkDUDOJEklzCeRokolTCdNZEuoyyrPJaRnz+dL5uSrwahnbcyr6WJoyuwLJywvb28sCPKw7hyc5THmbOxLryqqCu3ecU3xLTBz9TLIqza3rbYzgYw1t3jw5Wo4bLi7S81qeSor6+yhszylvRQ2KDYyJnixYqr6J2sdvnLJdC+dp40YqnkFa/c4xu/YvY7FQ7O1yIZymMCBDkST1fUQ3xNG6kfVsacv4KxizjjFU4nvYcqI+f8I00jSh0ucuZ/d2FnXZwle0GzaH4kQKkSXBgz3zXdRR8Ym6o0tRepXlytrJEovAQTV6dqrTZlFZiWWaVWorqstysk0aday3sSQQSdSplm7afUTTonX4Jq7HnK1mZcsG1ifAlzBtCNra9QZfzZvdGWCUqBZoLKJHUyltGgrq1E5Ws1bi+vWYkLIJKa4tJjZuTbd3d9HtmyLt4I16E68C/Djc4cp/G2/+5Tn0M9KnJ0lu/Uj17ERmcEceIrz48eTLmz+PPr368gUAADs=',
      signHidden: false,
      context: null,
      startX: 0,
      startY: 0,
      moveX: 0,
      moveY: 0,
      endX: 0,
      endY: 0,
      points: [],
      width: window.innerWidth - 20,
      height: 300
    }
  },
  created () {
    // 修改父路由头部文字
    const query = this.$route.query
    this.linkedId = query.linkedId

    this.getBusinessDetail()
  },
  mounted () {
    var canvas = this.$refs.canvasF
    this.context = canvas.getContext('2d')
    this.context.fillStyle = '#FFF'
    this.context.lineWidth = 2
    this.context.strokeStyle = '#000'
  },
  methods: {
    getBusinessDetail () {
      const params = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid'),
        linkedId: this.linkedId
      }
      getBusDetailReq(params).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          // 修改父路由头部文字
          this.$parent.changeBusstypeText(res.data.serviceName, res.data.stepName)
          this.contractSrc = this.filePath + res.data.contractForm.contractImg
          this.datas = res.data
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取业务信息失败' })
        })
    },
    // 提交签名
    getimg () {
      if (this.isDraw) {
        // 签名img回传后台
        this.signSrc = this.$refs.canvasF.toDataURL()
        this.signStatusChange()
        this.submitVisible = true
      } else {
        Notify({ type: 'warning', message: '请填写您的签名' })
      }
    },
    submitSign () {
      // 这下面写接口，这里传base64格式给后台
      this.loadingSign = true
      const url = '/uploadFile'
      const formData = new FormData()
      formData.append('file', this.dataURLtoBlob(this.signSrc))
      formDataPost('/business' + url, formData).then(response => {
        const data = JSON.parse(response.request.response)
        if (data.code === 200) {
          const contractParams = {
            id: this.datas.contractForm.contractId,
            url: data.fileId
          }
          const params = {
            token: this.$cookies.get('token'),
            openId: this.$cookies.get('openid'),
            currentModelId: this.datas.modelId,
            linkedId: this.linkedId,
            data: JSON.stringify(contractParams),
            type: 3
          }
          nextBusinessReq(params).then(response => {
            const res = response.data
            this.loadingSign = false
            if (res.code === 200) {
              const localPage = res.data.localPage
              this.$router.push({
                path: localPage,
                query: {
                  token: this.$cookies.get('token'),
                  linkedId: res.data.linkedId
                }
              })
            }
          })
            .catch((res) => {
              this.loadingSign = false
              Notify({ type: 'danger', message: '提交签名失败' })
            })
        } else {
          this.loadingSign = false
        }
      }).catch((res) => {
        this.loadingSign = false
        Notify({ type: 'danger', message: '上传签名失败' })
      })
    },
    checkSign () {
      this.checkStatus = !this.checkStatus
    },
    signStatusChange () {
      if (this.signHidden) {
        this.signHidden = false
      } else {
        this.signHidden = true
      }
    },
    touchStart (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length === 1) {
        const obj = {
          x: ev.targetTouches[0].clienX,
          y: ev.targetTouches[0].clientY
        }
        this.startX = obj.x
        this.startY = obj.y
        this.context.beginPath()
        this.context.moveTo(this.startX, this.startY)
        this.context.lineTo(obj.x, obj.y)
        this.context.stroke()
        this.context.closePath()
        this.points.push(obj)
      }
    },
    touchMove (ev) {
      ev = ev || event
      ev.preventDefault()
      if (ev.touches.length === 1) {
        var obj = {
          x: ev.targetTouches[0].clientX,
          y: ev.targetTouches[0].clientY - 145
        }
        this.moveY = obj.y
        this.moveX = obj.x
        this.context.beginPath()
        this.context.moveTo(this.startX, this.startY)
        this.context.lineTo(obj.x, obj.y)
        this.context.stroke()
        this.context.closePath()
        this.startX = obj.x
        this.startY = obj.y
        this.points.push(obj)
      }
    },
    touchEnd (ev) {
      ev = ev || event
      ev.preventDefault()
      this.isDraw = true
      if (ev.touches.length === 1) {
        const obj = {
          x: ev.targetTouches[0].clientX,
          y: ev.targetTouches[0].clientY - 145
        }
        this.context.beginPath()
        this.context.moveTo(this.startX, this.startY)
        this.context.lineTo(obj.x, obj.y)
        this.context.stroke()
        this.context.closePath()
        this.points.push(obj)
      }
    },
    cleardraw: function () {
      // 清除画布
      // this.arrx = []
      // this.arry = []
      this.isDraw = false
      this.submitVisible = false
      this.signSrc = 'data:image/gif;base64,R0lGODlhhwBIAJECAL6+vtHR0f///wAAACH5BAEAAAIALAAAAACHAEgAAAL/jI+py+0Po5y02ouz3rz7Dx7CSJbmiabqyrbuC6NLTNf2jddKzvf+r9oBh8TiS2hMKo3IpfOJa0KnVJa0is0Krtruk+sNMxPi8hJsTufQ6jaN7Y634PK6jGzPu+j6PL9f9wcYJzjYVmiYhphYtngCAMkDUDOJEklzCeRokolTCdNZEuoyyrPJaRnz+dL5uSrwahnbcyr6WJoyuwLJywvb28sCPKw7hyc5THmbOxLryqqCu3ecU3xLTBz9TLIqza3rbYzgYw1t3jw5Wo4bLi7S81qeSor6+yhszylvRQ2KDYyJnixYqr6J2sdvnLJdC+dp40YqnkFa/c4xu/YvY7FQ7O1yIZymMCBDkST1fUQ3xNG6kfVsacv4KxizjjFU4nvYcqI+f8I00jSh0ucuZ/d2FnXZwle0GzaH4kQKkSXBgz3zXdRR8Ym6o0tRepXlytrJEovAQTV6dqrTZlFZiWWaVWorqstysk0aday3sSQQSdSplm7afUTTonX4Jq7HnK1mZcsG1ifAlzBtCNra9QZfzZvdGWCUqBZoLKJHUyltGgrq1E5Ws1bi+vWYkLIJKa4tJjZuTbd3d9HtmyLt4I16E68C/Djc4cp/G2/+5Tn0M9KnJ0lu/Uj17ERmcEceIrz48eTLmz+PPr368gUAADs='
      this.context.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
    },
    // base64转Blob
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    }
  }
}
</script>

<style scoped>
@import url('../../assets/icondefault/css/font-awesome.min.css');
.dis-bok {
  display: block;
}
.mt-10 {
  margin-top: 10px;
}
.contract-sign-check {
  font-size: 16px;
  -webkit-box-shadow: #666 0px 0px 5px;
  -moz-box-shadow: #666 0px 0px 5px;
  box-shadow: #666 0px 0px 5px;
  line-height: 25px;
  border-radius: 4px;
  margin: -30px 30px 15px 30px;
  background-color: #fff;
}
.contract-text {
  padding: 10px 15px 10px 15px;
  background-color: #fff;
}
.contract-text-next {
  padding-bottom: 10px;
  color: rgb(0, 98, 255);
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px #e5e5e5 solid;
}
.read-text {
  height: 30px;
  line-height: 30px;
  margin: 10px 0;
  padding: 10px 15px 5px 15px;
  font-weight: 700;
  font-size: 16px;
  border-bottom: 1px #e5e5e5 solid;
  background-color: #f7f7f7;
}
.contract-remind {
  padding: 0 10px;
  font-size: 14px;
}
.contract-sign-img {
  padding-top: 6px;
  margin-right: 5px;
  width: 16px;
  height: 16px;
}
.contract-src {
  font-size: 15px;
  text-decoration: underline;
  color: rgb(0, 98, 255);
}
.sign-check-p {
  padding: 0 15px;
  border: 0px solid red;
  font-size: 13px;
}
.sign-check-p input[type='checkbox'] {
  display: none;
}
.sign-check-p input[type='checkbox']:checked + span:before {
  color: #53D76A;
  background-color: #fff;
}
.sign-check-p input[type='checkbox']:checked + span:before {
  font-family: FontAwesome;
  content: '\f00c';
  font-size: 16px;
  text-align: center;
  line-height: 20px;
  border: 1px solid #ccc;
}
.sign-check-p input[type='checkbox'] + span:before {
  display: -moz-inline-stack;
  display: inline-block;
  vertical-align: middle;
  zoom: 1;
  position: relative;
  bottom: 1px;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  content: '';
  border: 1px solid #ccc;
}
.sign-position {
  width: 100%;
  height: 150px;
}
.sign-position .canvas-img {
  width: 100%;
  height: 100%;
}
.mask-mine {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: .5;
  z-index: 1000;
  padding-bottom: constant( safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.sign-content {
  position: fixed;
  z-index: 9999;
  padding-bottom: constant( safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.sign-header {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  background: #fff;
}
.sign-container {
  box-sizing: border-box;
  flex: 1;
  background: #f5f5f5;
  font-size: 0;
}
.canvasImg {
  width: 135px;
  height: 72px;
  display: inline-block;
  margin-right: 19px;
  border: 1px solid rgb(49, 48, 48);
}
.sign-simmit {
  display: inline-block;
  height: 40px;
  margin-top: 10px;
  margin-right: 20px;
  width: 135px;
}
.sign-footer {
  width: 100%;
  height: 45px;
  background: #fff;
  text-align: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.btn-sign {
  width: 80px;
  height: 32px;
  border-radius: 16px;
  font-size: 14px;
  color: #fff;
  outline: none;
  border: 0;
}
.btn-reset {
  background: #999999;
}
.btn-save {
  background: #ff3737;
}
.go-business {
  margin-left: 25px;
  width: calc(100% - 50px);
  display: inline-block;
  margin-top: 0px;
  text-align: center;
}
.button-primary {
  height: 48px;
  line-height: 48px;
  background-color: #008ACB;
  font-size: 16px;
  color: #fff;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
